import React, { FC } from 'react'
import Layout from 'components/layout/Layout'

const App: FC = () => <Layout />

export default App
